export const optionsSexo = [
    { label: 'Feminino',
        value: 'Feminino' },
    { label: 'Masculino',
        value: 'Masculino' },
    { label: 'Outros',
        value: 'Outros' }
];

export const categoriasPet = ['ZPE26','ZPEAD','ZPET','ZPETA','ZPETL'];
export const montarArrayDependentesComParentesco = async (arrayDependentes,arrayParentesco) => {
    const arrayDependentesParentesco = arrayDependentes.map(dependente => {
        const [value] = arrayParentesco.filter(
            parentesco => parentesco.label === dependente.Parentesco
        );
        const { value: ParentescoValue } = value;

        return {
            ...dependente,
            ParentescoValue
        };
    });

    return arrayDependentesParentesco;
};

export const tratarRetornoCamposBackend = objRetorno =>{
    if (objRetorno.Nome === null) {objRetorno.Nome = '';}

    if (objRetorno.Telefone === null) {objRetorno.Telefone = '';}

    if (objRetorno.CPF === null) {objRetorno.CPF = '';}

    if (objRetorno.Email === null) {objRetorno.Email = '';}

    if (objRetorno.DepSexo === null) {objRetorno.DepSexo = '';}

    if (objRetorno.Categoria === null) {objRetorno.Categoria = '';}

    if (objRetorno.Parentesco === null) {objRetorno.Parentesco= '';}

    if (objRetorno.Idade === null) {objRetorno.Idade = '';}

    return objRetorno;
};

export const calcularIdade = (dateString,editar=false) =>{
    const hoje = new Date();
    let dataNascimento = null;

    if(editar){
        const [dia, mes, ano] = dateString.split('/');

        dataNascimento = new Date(ano, mes, dia);
    }else{
        dataNascimento = new Date(dateString);
    }

    let idade = hoje.getFullYear() - dataNascimento.getFullYear();

    if (idade === -1){
        idade++;
    }

    if( hoje.getMonth() < dataNascimento.getMonth()){
        idade--;
    }

    if ( hoje.getMonth() === dataNascimento.getMonth() && hoje.getDate() < dataNascimento.getDate()){
        idade--;
    }

    return idade;
};

export const categoriasPossiveisPorPlano = (categorias, plano) => {
    const categoriasFiltradas = categorias.filter(categoria => {
        if (categoria.PlanosAceitos.find(planoPossivel => planoPossivel.trim() === plano)) {
            return categoria;
        }
    });

    return categoriasFiltradas;
};

export const removerDependentePetPlanosPermitidos = (parentescos = [], plano = '',categorias ) => {
    const planosPermitidos = ['ZPC','ZP','ZPA','ZPC','ZP4','ZPCA','ZPET'];

    if (!categorias.find(({ value })=> categoriasPet.includes(value)) && plano.substring(0, 4) !== 'ZPET'){
        return parentescos.filter(({ value }) => value?.trim() !== 'PET');
    }

    return parentescos;
};